import styles from './Bunner.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlertOutline.svg';

export default function Bunner({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className={styles.info}>
      <div className={styles.info_top}>
        <div className={styles.info_title}>
          <IconAlert />
          <span>{title}</span>
        </div>
      </div>
      <div>
        <p>{description}</p>
      </div>
    </div>
  );
}
